// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xAmD","question":"styles_question__98enz","description":"styles_description__16PaM"};